/* EcomHub Pro — Bundle Deals: dynamic pricing + add to cart */
(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cts = parts[1] ? decimal + parts[1] : '';
      return dollars + cts;
    }
    var match = (format || '${{amount}}').match(placeholder);
    var token = match ? match[1] : 'amount';
    switch (token) {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'"); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' '); break;
      default: value = fmt(cents, 2);
    }
    return (format || '${{amount}}').replace(placeholder, value);
  }

  function initBundle(root) {
    if (root.__ehpBnd) return;
    root.__ehpBnd = true;
    var dynamic = root.getAttribute('data-dynamic') === '1';
    var money = root.getAttribute('data-money-format') || '${{amount}}';
    var secPct = parseFloat(root.getAttribute('data-section-pct')) || 0;
    var secFixed = parseInt(root.getAttribute('data-section-fixed'), 10) || 0;
    var skipCart = root.getAttribute('data-skip-cart') === '1';
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-bnd-item]'));
    var finalEl = root.querySelector('[data-bnd-final]');
    var totalVal = root.querySelector('.ehp-bnd__total-val');
    var atc = root.querySelector('[data-bnd-atc]');
    var err = root.querySelector('[data-bnd-err]');

    function state(item) {
      var check = item.querySelector('[data-bnd-check]');
      var checked = check ? check.checked : true;
      var sel = item.querySelector('[data-bnd-variant]');
      var price, vid;
      if (sel && sel.options.length) {
        var opt = sel.options[sel.selectedIndex];
        price = parseInt(opt.getAttribute('data-price'), 10);
        vid = opt.value;
      } else {
        price = parseInt(item.getAttribute('data-base'), 10);
        vid = item.getAttribute('data-variant-id');
      }
      var pct = parseFloat(item.getAttribute('data-prod-pct')) || 0;
      var fixed = parseInt(item.getAttribute('data-prod-fixed'), 10) || 0;
      var disc = price;
      if (pct) disc = Math.round(disc * (100 - pct) / 100);
      if (fixed) disc = disc - fixed;
      if (disc < 0) disc = 0;
      return { checked: checked, vid: vid, base: price, disc: disc };
    }

    function recompute() {
      var sumOrig = 0, sumDisc = 0, any = false;
      items.forEach(function (it) {
        var st = state(it);
        var lp = it.querySelector('[data-bnd-lineprice]');
        if (lp) {
          var was = st.disc < st.base ? '<s class="ehp-bnd__was">' + formatMoney(st.base, money) + '</s>' : '';
          lp.innerHTML = was + '<span class="ehp-bnd__now">' + formatMoney(st.disc, money) + '</span>';
        }
        it.classList.toggle('is-off', !st.checked);
        if (st.checked) { sumOrig += st.base; sumDisc += st.disc; any = true; }
      });
      var total = sumDisc;
      if (secPct) total = Math.round(total * (100 - secPct) / 100);
      if (secFixed) total = total - secFixed;
      if (total < 0) total = 0;
      if (finalEl) finalEl.textContent = formatMoney(total, money);
      var cmp = root.querySelector('[data-bnd-compare]');
      if (total < sumOrig) {
        if (!cmp && totalVal) {
          cmp = document.createElement('s');
          cmp.className = 'ehp-bnd__was';
          cmp.setAttribute('data-bnd-compare', '');
          totalVal.insertBefore(cmp, finalEl);
        }
        if (cmp) cmp.textContent = formatMoney(sumOrig, money);
      } else if (cmp) {
        cmp.parentNode.removeChild(cmp);
      }
      if (atc) atc.disabled = !any;
    }

    function showErr(m) {
      if (!err) return;
      err.textContent = m;
      err.hidden = false;
      setTimeout(function () { err.hidden = true; }, 4000);
    }

    if (dynamic) {
      root.addEventListener('change', function (e) {
        if (e.target.closest('[data-bnd-check]') || e.target.matches('[data-bnd-check]') || e.target.matches('[data-bnd-variant]')) {
          recompute();
        }
      });
      recompute();
    }

    if (atc) {
      atc.addEventListener('click', function () {
        var selected = items.map(state).filter(function (s) { return s.checked && s.vid; });
        if (!selected.length) { showErr('Select at least one product.'); return; }
        if (skipCart) {
          window.location.href = '/cart/' + selected.map(function (s) { return s.vid + ':1'; }).join(',');
          return;
        }
        atc.classList.add('is-loading');
        atc.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: selected.map(function (s) { return { id: s.vid, quantity: 1 }; }) })
        })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function () { window.location.href = '/cart'; })
          .catch(function () {
            atc.classList.remove('is-loading');
            atc.disabled = false;
            showErr('Could not add to cart. Please try again.');
          });
      });
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-ehp-bundle]').forEach(initBundle);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
